import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import { T } from '../../../../../Translations';
import ModalStore from '../../../../Modal/Store';
import InvitationsStore from '../Store';
import InvitationStore from '../Store/InvitationStore';
import { InvitationResource, InvitationsResource } from '../Store/Types';
import Body from './Body';
import Head from './Head';
import Pagination from './Pagination';

interface Props {
  invitationsResource: InvitationsResource;
  store: InvitationsStore;
  invitationStore: InvitationStore;
  multicheckStore: MulticheckStore<InvitationResource>;
  modalStore: ModalStore;
}

function InvitationsTable({
  store,
  invitationStore,
  invitationsResource,
  multicheckStore,
  modalStore,
}: Props) {
  return fromEmpty(invitationsResource.payload.invitations)
    .map((i) => (
      <>
        <table className="min-w-full divide-y divide-gray-300">
          <Head
            searchParameters={store.searchParameters}
            multicheckStore={multicheckStore}
            sorting={store.sorting}
          />
          <Body
            invitationStore={invitationStore}
            invitations={i}
            multicheckStore={multicheckStore}
            modalStore={modalStore}
          />
        </table>
        <Pagination store={store} invitationsResource={invitationsResource} />
      </>
    ))
    .getOrElse(() => <T kind="No Results" />);
}

export default observer(InvitationsTable);
